var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-column",class:{ 'mb-3 mt-1': !_vm.dense }},[_c('v-skeleton-loader',{attrs:{"max-width":"128","height":"17","type":"text"}}),_vm._v(" "),_c('v-skeleton-loader',{staticClass:"mt-3",attrs:{"width":"80%","height":"18","type":"text"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }